import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _defineProperty from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsxImportSource @emotion/react */
import { useRouter } from 'next/router';
import { Typography } from "@vc-workspace/utils-typography";
import Checkbox from '@mui/material/Checkbox';
import { filterItemContainer } from './category-filters.module.style';
import { Colors } from "@vc-workspace/utils-colors";
import { CategoryFilterKey } from '@vc-workspace/utils-constants';
import { useState, useEffect } from 'react';
import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import { convertJsonToQueryString } from '@vc-workspace/utils-formatters';
/* eslint-disable-next-line */

export function CategoryFilters(props) {
  var router = useRouter();

  var _useState = useState(!props.showPaginatedFilters),
      showAllFilters = _useState[0],
      toggleFiltersVisibility = _useState[1];

  var _useState2 = useState(function () {
    var filterInQuery = [];

    if (props.context.query[CategoryFilterKey]) {
      if (typeof props.context.query[CategoryFilterKey] === 'string') {
        filterInQuery = [props.context.query[CategoryFilterKey]];
      } else {
        filterInQuery = _toConsumableArray(props.context.query[CategoryFilterKey]);
      }
    }

    return filterInQuery;
  }),
      appliedFilters = _useState2[0],
      setAppliedFilter = _useState2[1];

  useEffect(function () {
    if (!props.context.query[CategoryFilterKey]) {
      setAppliedFilter([]);
    }
  }, [props.context]);

  if (!props.filterDetails || !props.filterDetails.filterValues.length) {
    return null;
  }

  var filterOptions = [];

  function onFilterItemClick(filterValue) {
    var updatedFilters = _toConsumableArray(appliedFilters);

    if (updatedFilters.indexOf(filterValue) !== -1) {
      updatedFilters = updatedFilters.filter(function (item) {
        return item !== filterValue;
      });
    } else {
      updatedFilters = [].concat(_toConsumableArray(updatedFilters), [filterValue]);
    }

    var query = props.context.query;
    delete query[CategoryFilterKey];
    setAppliedFilter(updatedFilters);

    if (props.onFilterSelect) {
      props.onFilterSelect(_defineProperty({}, CategoryFilterKey, updatedFilters));
    }

    if (!props.preventNavigation) {
      router.push("".concat(props.context.pathname, "?").concat(convertJsonToQueryString(_objectSpread(_objectSpread({}, query), {}, _defineProperty({}, CategoryFilterKey, updatedFilters)))));
    }
  }

  props.filterDetails.filterValues.forEach(function (item) {
    filterOptions.push({
      label: item.displayName,
      value: item.value,
      active: appliedFilters.indexOf(item.value) !== -1,
      query: {},
      itemCount: item.displayCount
    });
  });

  if (!showAllFilters) {
    filterOptions = filterOptions.slice(0, 6);
  }

  return _jsxs(_Fragment, {
    children: [!props.withoutHeading ? _jsx(Typography, {
      type: "SubHeading1",
      color: "nero",
      className: "pb-2",
      bold: true,
      children: "Category"
    }) : null, filterOptions.map(function (filterItem) {
      return _jsxs("div", {
        css: filterItemContainer,
        onClick: function onClick() {
          return onFilterItemClick(filterItem.value);
        },
        children: [_jsx(Checkbox, {
          icon: _jsx(CheckBoxOutlineBlankRoundedIcon, {}),
          checkedIcon: _jsx(CheckBoxRoundedIcon, {}),
          sx: {
            color: Colors.dim_grey,
            '&.Mui-checked': {
              color: Colors.nero
            }
          },
          checked: filterItem.active
        }), _jsxs("div", {
          children: [_jsx(Typography, {
            type: "Body1",
            color: "dim_grey",
            bold: filterItem.active,
            inline: true,
            children: filterItem.label
          }), filterItem.itemCount ? _jsxs(Typography, {
            type: "Body2",
            color: "dim_grey",
            className: "pl-2",
            inline: true,
            children: ["(", filterItem.itemCount, " Items)"]
          }) : null]
        })]
      }, filterItem.value);
    }), !showAllFilters && props.filterDetails.filterValues.length > 6 && props.showPaginatedFilters ? _jsxs(Typography, {
      type: "Body1",
      color: "purple_heart",
      className: "pl-10 pt-2",
      onClick: function onClick() {
        return toggleFiltersVisibility(true);
      },
      bold: true,
      children: ["+", props.filterDetails.filterValues.length - 6, " more categories"]
    }) : null]
  });
}
export default CategoryFilters;